import Vue from 'vue';
import VueGtag from 'vue-gtag';

export default {
  methods: {
    $loadGa() {
      var analytics = this.$store.getters['config/analytics'];
      var options = {
        config: { id: analytics.gtagId }
      };

      // Register the Google Ads tag as a second destination. Two things depend on it:
      // remarketing lists only accumulate for a configured AW- destination, and the existing
      // checkout conversions (which send_to this id) were relying on it being implicitly known.
      // allow_enhanced_conversions lets the purchase events carry hashed user data.
      if (analytics.googleAdsConversionId) {
        options.includes = [
          {
            id: analytics.googleAdsConversionId,
            params: { allow_enhanced_conversions: true }
          }
        ];
      }

      Vue.use(VueGtag, options);
    }
  }
};
